<div class="wrapper-landing-business-page">
  <div class="header-business-page">
    <span class="header-title-business-page">Povećajte vidljivost i poslujte bez naknade</span>
    <span class="header-subtitle-business-page">Welcome to Burger Bliss, where we take your cravings to a whole new level! Our mouthwatering burgers are made from 100% beef and are served on freshly baked buns. </span>
    <button [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" [state]="{isBusiness: true}" class="custom-btn custom-btn--white">
      <span>Postanite partner</span>
    </button>
    <div class="wrapper-business-social-network">
      <a href="">
        <img src="../../../../assets/icons/landing/icon-business-instagram.svg" alt="">
      </a>
      <a href="">
        <img src="../../../../assets/icons/landing/icon-business-youtube.svg" alt="">
      </a>
      <a href="">
        <img src="../../../../assets/icons/landing/icon-business-facebook.svg" alt="">
      </a>
      <a href="">
        <img src="../../../../assets/icons/landing/icon-business-tiktok.svg" alt="">
      </a>
    </div>
  </div>
  <!--  -->
  <div class="wrapper-three-step-description">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__l-6 xs-mb-120">
          <div class="wrapper-content-step-desc">
            <h1>Besplatna aplikacija bez finansijskih obaveza i naknada</h1>
            <p>Welcome to Burger Bliss, where we take your cravings to a whole new level! Our mouthwatering burgers are made from 100% beef and are served on freshly baked buns.</p>
            <button class="custom-btn custom-btn--purple">
              <span>Registruj se</span>
            </button>
          </div>
        </div>
        <div class="grid__l-6 xs-mb-120">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step1-desc.svg" alt="">
          </div>
        </div>
        <div class="grid__l-6 xs-mb-120">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step2-desc.svg" alt="">
          </div>
        </div>
        <div class="grid__l-6 xs-mb-120">
          <div class="wrapper-content-step-desc">
            <h1>Daleko veća mogućnost vidljivosti prema fizičkim licima</h1>
            <p>Welcome to Burger Bliss, where we take your cravings to a whole new level! Our mouthwatering burgers are made from 100% beef and are served on freshly baked buns.</p>
          </div>
        </div>
        <div class="grid__l-6">
          <div class="wrapper-content-step-desc">
            <h1>Preglednije vodjenje evidencije termina i usluga</h1>
            <p>Welcome to Burger Bliss, where we take your cravings to a whole new level! Our mouthwatering burgers are made from 100% beef and are served on freshly baked buns.</p>
            <button class="custom-btn custom-btn--purple">
              <span>Povećajte doseg</span>
            </button>
          </div>
        </div>
        <div class="grid__l-6">
          <div class="wrapper-image-three-step">
            <img src="../../../../assets/images/landing/illustration-step3-desc.svg" alt="">
          </div>
        </div>
    </div>
  </div>
  </div>
  <!--  Largest business partners section -->
  <div class="wrapper-business-partner">
    <div class="zc-container">
      <div class="wrapper_largest_business_partners">
        <div class="grid">
          <div class="grid__s-12">
            <span class="small-title">Najveći biznis partneri</span>
          </div>
        </div>
        <div class="grid">
          <div *ngFor="let partner of businessPartners" class="grid__l-4">
            <a *ngIf="banners.B?.length && banners.B[partner]" [href]="banners.B[partner].link" target="_blank">
              <div class="wrapper-banner-image-largest-business">
                <img [src]="banners.B[partner].image.full_path" alt="">
              </div>
            </a>
            <div *ngIf="!banners.B?.length || !banners.B[partner]" class="wrapper-banner-empty">
              <img class="yellow-icon-banner" src="../../../../assets/icons/landing/illustration/illustration-yellow-empty-banner.svg" alt="">
              <img class="r-empty-banner" src="../../../../assets/icons/landing/illustration/illustration-r-empty-banner.svg" alt="">
              <div class="content-empty-banner">
                <img src="../../../../assets/icons/landing/illustration/white-r.svg" alt="">
                <span>Mesto za</span>
                <span><b>Vašu reklamu!</b></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FAQ section -->
  <div class="wrapper-faq-section">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__s-12">
          <div class="wrapper-faq">
            <div class="wrapper-title faq">
              <h2>Česta <span>pitanja</span></h2>
              <img src="../../../../assets/icons/landing/illustration/faq-illustration.svg" alt="">
            </div>
            <div class="wrapper-content-faq">
              <div *ngFor="let faq of faqs; index as faqIndex" class="wrapper-question" (click)="faqIndex === activeFaqIndex ? activeFaqIndex = -1 : activeFaqIndex = faqIndex"  [ngClass]="{'collapsed': faqIndex === activeFaqIndex}">
                <span class="title-question">{{ faq.question }}</span>
                <span class="description-answer">{{ faq.answer }}</span>
                <img class="icon-star-green" src="../../../../assets/icons/landing/icon-star-green.svg" alt="">
                <img class="icon-blue plus" src="../../../../assets/icons/landing/icon-plus-blue.svg" alt="">
                <img class="icon-blue minus" src="../../../../assets/icons/landing/Icon-minus-blue.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section -->
  <div class="wrapper-newsletter">
    <span class="title-newsletter">Prijavite se i dobijajte najnovije informacije</span>
    <span class="subtitle-newsletter">Write your concern to us and our specialist will get back to you.</span>
    <form [formGroup]="newsletterForm" (ngSubmit)="onSubmitPostNewsletterForm()" class="form-newsletter">
      <div class="wrapper-input-landing">
        <div class="custom-input">
          <input [formControl]="newsletterForm.controls.email | formControl" type="text" placeholder="">
        </div>
        <span class="error-message">{{newsletterForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : newsletterFormTriedToSubmit}}</span>
      </div>
      <button type="submit" class="custom-btn custom-btn--purple">
        <span>Pošaljite</span>
      </button>
    </form>
  </div>
</div>
